const LOCAL_STORAGE_PREFIX = 'glspartnerportal-';

export { LOCAL_STORAGE_PREFIX };
